import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box/Box';
import Paper from '@mui/material/Paper/Paper';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';

import Order from '@/shared/types/order/order.type';
import formatCurrency from '@/shared/utils/formatCurrency';

type PaymentsListProps = {
  order: Order;
  amountOwed: number;
};

const PaymentsList: FC<PaymentsListProps> = ({ order, amountOwed }) => {
  const { t } = useTranslation(['checkout', 'common']);

  const sortedPayments = order.payments.sort(
    (a, b) =>
      new Date(a.ts_created).getTime() - new Date(b.ts_created).getTime(),
  );

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant='body1' mb={2}>
        {t('common:payments')}
      </Typography>

      <Stack spacing={2}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant='body2'>Amount Owed</Typography>
          <Typography variant='body2'>-{formatCurrency(amountOwed)}</Typography>
        </Box>

        {sortedPayments.map((payment) => (
          <Box
            key={payment.in_transaction_id}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant='body2'>{payment.payment_method}</Typography>
            <Typography variant='body2'>
              {formatCurrency(parseFloat(payment.transaction_amount))}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export default PaymentsList;
